import { Theme, css } from '@emotion/react';

export const formBlockContainer = ({ spacing }: Theme) => css`
  width: 100%;
  > :not(:first-of-type) {
    margin-top: ${spacing(3)}px;
  }
`;

export const dividerContainer = ({ spacing }: Theme) => css`
  margin-top: ${spacing(5)}px;
`;

export const headerContainer = ({ spacing }: Theme) => css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${spacing(2)}px;
`;

export const textContainer = ({ spacing }: Theme) => css`
  display: grid;
  gap: ${spacing(1)}px;
`;

export const actionsContainer = css`
  flex-shrink: 0;
`;
